
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {
  }
})
export default class WSAPageFive extends Vue {
  @Prop() model: any;
  @Prop() isOver18: number;
  formModel: WSAPageFiveModel;

  data() {
    return {
      formModel: null
    }
  }

  created() {
    this.formModel = {
      ...this.model
    }
  }

  get showGuardianForm(): boolean {
    return this.isOver18 === 0;
  }

  @Emit('previousPage')
  async handlePreviousClick() {
    return { ...this.formModel };
  }
}
